<template>
<div id="transportistas" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Administrar Transportistas" class="elevation-1 px-5 py-3" >
                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-speed-dial direction="left" open-on-hover>
                            <template v-slot:activator>
                                <v-btn x-small fab dark color="primary" >
                                    <v-icon>reorder</v-icon>
                                </v-btn>
                            </template>
                            <exportar-excel :data="datafiltered" :exportFields="registros.camposexcel" name="Transportistas.xlsx" >
                                <v-btn fab x-small dark color="success" title="Exportar" v-tippy>
                                    <v-icon dark>get_app</v-icon>
                                </v-btn>
                            </exportar-excel>
                            <upload-excel-component :on-success="handleSuccess" :before-upload="beforeUpload" />
                            <exportar-excel :data="registros.camposLayout" :exportFields="registros.encabezadoLayout" name="Layout Transportistas.xlsx" >
                                <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                    <v-icon dark>receipt</v-icon>
                                </v-btn>
                            </exportar-excel>
                        </v-speed-dial>

                        <v-btn fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>

                        <v-dialog v-model="modal" max-width="60%" style=" z-index: 400 !important;" >
                            <v-card>
                                <v-card-title>
                                    <v-card class="primary white--text titulomodal" >
                                        <v-icon class="white--text" >{{
                        update ? "edit" : "add"
                      }}</v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>{{ update ? "Actualizar" : "Nuevo" }} Transportista</strong>
                                        </span>
                                    </v-card>
                                    <v-spacer></v-spacer>
                                    <v-btn icon @click.native="modal = false" class="close_modal" >
                                        <v-icon class="white--text" >cancel</v-icon>
                                    </v-btn>
                                </v-card-title>
                                <v-form ref="form" lazy-validation>
                                    <v-card-text>
                                        <v-container grid-list-md text-xs-center @keyup.enter="guardar()" >
                                            <v-layout row wrap>
                                                <v-flex s12 m6 l6>
                                                    <v-text-field name="nombre" label="Nombre" type="text" v-model="model.nombre" :rules="[rules.required]" maxlength="100" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m6 l6>
                                                    <v-text-field name="rfc" label="RFC o TAX ID" type="text" @input="model.rfc = model.rfc.toUpperCase()" v-model="model.rfc" :rules="[rules.required, rules.rfclen]" maxlength="20" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m3 l3>
                                                    <v-text-field name="telefono" label="Teléfono" type="text" v-model="model.telefono" :rules="[rules.required]" maxlength="50" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m3 l3>
                                                    <v-text-field label="Calle" type="text" v-model="model.calle" maxlength="150" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m3 l3>
                                                    <v-text-field label="No. Exterior" type="text" v-model="model.numero_exterior" maxlength="10" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m3 l3>
                                                    <v-text-field label="No. Interior" type="text" v-model="model.numero_interior" maxlength="10" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m6 l6>
                                                    <v-text-field label="Colonia" type="text" v-model="model.colonia" maxlength="100" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m6 l6>
                                                    <v-text-field label="Código Postal" type="text" v-model="model.codigo_postal" maxlength="10" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m12 l12>
                                                    <!--OptionCombo: 1-Pais, 2-Pais,Estado, 3-Pais,Estado,Ciudad, 4-Pais,Estado,Municipio, 5-Pais,Estado,Ciudad,Municipio -->
                                                    <v-combo-paises :option_combos="5" :param_pais="model.pais" :param_estado="model.estado" :param_ciudad="model.ciudad" :param_municipio="model.municipio" :on-select-pais="selectComboPais" :on-select-estado="selectComboEstado" :on-select-ciudad="selectComboCiudad" :on-select-municipio="selectComboMunicipio" />
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m4 l4>
                                                    <v-text-field label="Banco" type="text" v-model="model.banco" maxlength="150" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m4 l4>
                                                    <v-text-field label="Sucursal" type="text" v-model="model.sucursal" maxlength="50" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m4 l4>
                                                    <v-text-field label="No. Cuenta" type="text" v-model="model.cuenta" maxlength="50" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m4 l4>
                                                    <v-text-field label="CLABE" type="text" v-model="model.clabe" maxlength="25" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m4 l4>
                                                    <v-text-field label="SWIFT" type="text" v-model="model.swift" maxlength="50" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m4 l4>
                                                    <v-text-field label="ABA" type="text" v-model="model.aba" maxlength="50" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m4 l4>
                                                    <v-text-field label="Banco Interamericano" type="text" v-model="model.banco_interamericano" maxlength="150" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m4 l4>
                                                    <v-text-field label="Beneficiario" type="text" v-model="model.beneficiario" maxlength="150" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m4 l4>
                                                    <v-text-field label="Referencia Banco" type="text" v-model="model.referencia_banco" maxlength="150" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m6 l6>
                                                    <v-text-field name="metadato" label="Metadato" type="text" v-model="model.metadato" :rules="[rules.required]" maxlength="100" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-form>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn @click.native="modal = false" >
                                        <v-icon>cancel</v-icon> Cancelar
                                    </v-btn>
                                    <v-btn color="success" :loading="loading" @click.native="guardar()" >
                                        <v-icon>done</v-icon>
                                        {{ update ? "Actualizar" : "Guardar" }}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>

                        <!--MODAL DOMICLIO-->
                        <v-dialog v-model="modalDomicilio" max-width="60%" style=" z-index: 400 !important;" >
                            <v-card>
                                <v-card-title>
                                    <v-card class="primary white--text titulomodal" >
                                        <v-icon class="white--text" >address-card</v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>Otros Domicilios {{' del transportista: '+registro_seleccionado_metadato}}</strong>
                                        </span>
                                    </v-card>
                                    <v-spacer></v-spacer>
                                    <v-btn icon @click.native="modalDomicilio = false" class="close_modal" >
                                        <v-icon class="white--text" >cancel</v-icon>
                                    </v-btn>
                                </v-card-title>
                                <v-form ref="formDomicilio" lazy-validation>
                                    <v-card-text>
                                        <v-container grid-list-md text-xs-center @keyup.enter="guardarDomicilio()" >
                                            <v-layout row wrap>
                                                <v-flex s12 m3 l3>
                                                    <v-text-field label="Calle" type="text" v-model="modelDomicilio.calle" maxlength="150" :rules="[rules.required]" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m3 l3>
                                                    <v-text-field label="No. Exterior" type="text" v-model="modelDomicilio.numero_exterior" maxlength="10" :rules="[rules.required]" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m3 l3>
                                                    <v-text-field label="No. Interior" type="text" v-model="modelDomicilio.numero_interior" maxlength="10" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m3 l3>

                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m6 l6>
                                                    <v-text-field label="Colonia" type="text" v-model="modelDomicilio.colonia" maxlength="100" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m16 l6>
                                                    <v-text-field label="Código Postal" type="text" v-model="modelDomicilio.codigo_postal" maxlength="10" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m12 l12>
                                                    <!--OptionCombo: 1-Pais, 2-Pais,Estado, 3-Pais,Estado,Ciudad, 4-Pais,Estado,Municipio, 5-Pais,Estado,Ciudad,Municipio -->
                                                    <v-combo-paises :option_combos="5" :param_pais="modelDomicilio.pais" :param_estado="modelDomicilio.estado" :param_ciudad="modelDomicilio.ciudad" :param_municipio="modelDomicilio.municipio" :on-select-pais="selectComboPaisDomicilio" :on-select-estado="selectComboEstadoDomicilio" :on-select-ciudad="selectComboCiudadDomicilio" :on-select-municipio="selectComboMunicipioDomicilio" />
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m4 l4>
                                                    <v-autocomplete v-model="modelDomicilio.aduana" :items="aduanas" :hide-no-data="true" :hide-selected="true" :item-text="nombreAduanaSelect" item-value="id_aduana" label="Selecciona una Aduana" :rules="[rules.required, uniqueAduanaDomicilio(modelDomicilio)]" ></v-autocomplete>
                                                </v-flex>
                                                <v-flex s12 m4 l4>
                                                    <v-text-field label="Notas" type="text" v-model="modelDomicilio.notas" maxlength="255" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-form>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn @click.native="modalDomicilio = false" >
                                        <v-icon>cancel</v-icon> Cancelar
                                    </v-btn>
                                    <v-btn color="success" :loading="loading" @click.native="guardarDomicilio()" >
                                        <v-icon>done</v-icon>Guardar
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>

                        <!--MODAL CONTACTO-->
                        <v-dialog v-model="modalContacto" max-width="60%" style=" z-index: 400 !important;" >
                            <v-card>
                                <v-card-title>
                                    <v-card class="primary white--text titulomodal" >
                                        <v-icon class="white--text" >address-book</v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>Información de Contactos {{' del transportista: '+registro_seleccionado_metadato}}</strong>
                                        </span>
                                    </v-card>
                                    <v-spacer></v-spacer>
                                    <v-btn icon @click.native="modalContacto = false" class="close_modal" >
                                        <v-icon class="white--text" >cancel</v-icon>
                                    </v-btn>
                                </v-card-title>
                                <v-form ref="formContacto" lazy-validation>
                                    <v-card-text>
                                        <v-container grid-list-md text-xs-center @keyup.enter="guardarContacto()" >
                                            <v-layout row wrap>
                                                <v-flex s12 m3 l3>
                                                    <v-autocomplete v-model="modelContacto.aduana" :items="aduanas" :hide-no-data="true" :hide-selected="true" :item-text="nombreAduanaSelect" item-value="id_aduana" label="Selecciona una Aduana" :rules="[rules.required, uniqueAduanaContacto(modelContacto)]" ></v-autocomplete>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex s12 m3 l3>
                                                    <v-text-field label="Nombre Contacto" type="text" v-model="modelContacto.nombre" maxlength="150" :rules="[rules.required]" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m3 l3>
                                                    <v-text-field label="Email" type="text" v-model="modelContacto.email" maxlength="150" :rules="[rules.required, rules.email]" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m3 l3>
                                                    <v-text-field label="Teléfono" type="text" v-model="modelContacto.telefono" maxlength="50" ></v-text-field>
                                                </v-flex>
                                                <v-flex s12 m3 l3>
                                                    <v-text-field label="Móvil" type="text" v-model="modelContacto.movil" maxlength="50" ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-form>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn @click.native="modalContacto = false" >
                                        <v-icon>cancel</v-icon> Cancelar
                                    </v-btn>
                                    <v-btn color="success" :loading="loading" @click.native="guardarContacto()" >
                                        <v-icon>done</v-icon>Guardar
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>

                    </v-card-actions>

                    <v-card-text>
                        <div id="datagrid" >

                            <v-client-table ref="principalTable" :data="registros.items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                </template>

                                <template slot="detail" slot-scope="props" >
                                    <v-btn text icon color="primary" title="Mostrar Domicilios" @click="showDetail(props.row)" >
                                        <v-icon v-if="registro_seleccionado != props.row.id_transportista" >add_circle</v-icon>
                                        <v-icon v-if="registro_seleccionado == props.row.id_transportista" >remove_circle</v-icon>                                        
                                    </v-btn>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                                        <template v-slot:activator>
                                            <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                                <v-icon>reorder</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-btn x-small fab dark color="blue" @click.native="
                          getRegistro(props.row.id_transportista)
                        " title="Editar Registro" v-tippy>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="pink" @click.native="
                          deleteRegistro(props.row.id_transportista)
                        " title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>

                                <template slot="child_row" >
                                    <v-app-bar dense height="35pt" >
                                        <span style="font-size:12pt" >Otros Domicilios {{registro_seleccionado == '' ? '[Seleccione un transportista para ver sus domicilios]' : ' del transportista: '+registro_seleccionado_metadato}}</span>
                                    </v-app-bar>
                                    <v-card-text>
                                        <div class="row" >
                                            <div class="col-xs-1" >
                                                <v-btn v-if="registro_seleccionado!=''" fab dark small color="green" @click="openModalOtro('domicilio',1)" title="Agregar Domicilio" v-tippy>
                                                    <v-icon dark>add</v-icon>
                                                </v-btn>
                                            </div>
                                        </div>
                                        <div class="row" >
                                            <div class="col-xs-10" ></div>
                                        </div>
                                        <v-client-table ref="vuetable" :data="domicilios.items" :columns="columnsDomicilios" :options="optionsDomicilios" class="elevation-2 pa-2" >
                                            <template slot="noResults" >
                                                <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                            </template>

                                            <template slot="actions" slot-scope="props" >
                                                <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                                                    <template v-slot:activator>
                                                        <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                                            <v-icon>reorder</v-icon>
                                                        </v-btn>
                                                    </template>

                                                    <v-btn icon small fab dark color="blue" @click.native="
                                  getRegistroDomicilio(props.row.id_domicilio_transportista)
                                " title="Editar Registro" v-tippy>
                                                        <v-icon>edit</v-icon>
                                                    </v-btn>
                                                    <v-btn icon small fab dark color="pink" @click.native="
                                  deleteRegistroDomicilio(props.row.id_domicilio_transportista)
                                " title="Eliminar Registro" v-tippy>
                                                        <v-icon>delete</v-icon>
                                                    </v-btn>
                                                </v-speed-dial>
                                            </template>
                                        </v-client-table>
                                    </v-card-text>
                                    <hr>
                                    <v-app-bar dense height="35pt" >
                                        <span style="font-size:12pt" >Información de Contactos {{registro_seleccionado == '' ? '[Seleccione un transportista para ver sus contactos]' : ' del transportista: '+registro_seleccionado_metadato}}</span>
                                    </v-app-bar>
                                    <v-card-text>
                                        <div class="row" >
                                            <div class="col-xs-1" >
                                                <v-btn v-if="registro_seleccionado!=''" fab dark small color="green" @click="openModalOtro('contacto',1)" title="Agregar Contacto" v-tippy>
                                                    <v-icon dark>add</v-icon>
                                                </v-btn>
                                            </div>
                                        </div>
                                        <div class="row" >
                                            <div class="col-xs-10" ></div>
                                        </div>
                                        <v-client-table ref="vuetable" :data="contactos.items" :columns="columnsContactos" :options="optionsContactos" class="elevation-2 pa-2" >
                                            <template slot="noResults" >
                                                <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                            </template>

                                            <template slot="actions" slot-scope="props" >
                                                <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                                                    <template v-slot:activator>
                                                        <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                                            <v-icon>reorder</v-icon>
                                                        </v-btn>
                                                    </template>

                                                    <v-btn icon small fab dark color="blue" @click.native="
                                  getRegistroContacto(props.row.id_contacto_transportista)
                                " title="Editar Registro" v-tippy>
                                                        <v-icon>edit</v-icon>
                                                    </v-btn>
                                                    <v-btn icon small fab dark color="pink" @click.native="
                                  deleteRegistroContacto(props.row.id_contacto_transportista)
                                " title="Eliminar Registro" v-tippy>
                                                        <v-icon>delete</v-icon>
                                                    </v-btn>
                                                </v-speed-dial>
                                            </template>
                                        </v-client-table>
                                    </v-card-text>
                                </template>

                            </v-client-table>
                        </div>
                    </v-card-text>

                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>

</div>
</template>

<script>
import axios from "axios";
import ComboPaises from '@/components/ComboPaises/index.vue';
import {
    Promise
} from 'q';

export default {
    components: {
        "v-combo-paises": ComboPaises,
    },

    data: () => ({
        fab: false,
        name: "datagrid",
        importData: [],
        columns: [
            "detail",
            "nombre",
            "rfc",
            "telefono",
            "calle",
            "metadato",
            "actions"
        ],
        options: {
            filterable: [
                "nombre",
                "rfc",
                "telefono",
                "calle",
                "metadato"
            ],
            sortable: [
                "nombre",
                "rfc",
                "telefono",
                "calle",
                "metadato"
            ],

            headings: {
                detail: '',
                nombre: "Nombre",
                rfc: "RFC o TAX ID",
                telefono: "Teléfono",
                calle: "Calle",
                metadato: "Metadato",
                actions: "Operaciones"
            },
            uniqueKey: "id_transportista",
        },
        URL: "",
        show_loading: true,
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Catálogos",
                disabled: true,
                to: ""
            },
            {
                text: "Transportistas",
                disabled: true,
                to: ""
            }
        ],
        loading: false,
        title: "",
        modal: false,
        modalDomicilio: false,
        modalContacto: false,
        update: false,
        pagination: {
            sortBy: "nombre"
        },
        search: "",
        model: {
            id_transportista: 0,
            nombre: "",
            rfc: "",
            telefono: "",
            cliente: 0,
            metadato: "N/A"
        },
        rules: {
            required: v => !!v || "Este campo es requerido",
            email: value => {
                const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return pattern.test(value) || "Correo electrónico no valido";
            },
            rfclen: v => (v && v.length >= 9) || "RFC debe tener al menos 9 caractéres",
        },
        aduanas: [],
        paises: [],
        estados: [],
        ciudades: [],
        municipios: [],
        estados_todos: [], //para verificar que el ID de estado en los layout exista
        registros: {
            selected: [],
            camposexcel: {
                Nombre: "nombre",
                RFC: "rfc",
                Teléfono: "telefono",
                Metadato: "metadato",
                Calle: "calle",
                "No. Exterior": "numero_exterior",
                "No. Interior": "numero_interior",
                Colonia: "colonia",
                "CP": "codigo_postal",
                Ciudad: "ciudad",
                Municipio: "municipio",
                Estado: "estado_nombre",
                Pais: "pais_nombre",
                Banco: "banco",
                Sucursal: "sucursal",
                Cuenta: "cuenta",
                Clabe: "clabe",
                Swift: "swift",
                Aba: "aba",
                "Banco Interamericano": "banco_interamericano",
                Beneficiario: "beneficiario",
                "Referencia Banco": "referencia_banco",
            },
            items: [0],
            //En el encabezado deben ser iguales los pares, respetando el nombre del campo definido en el modelo de la API
            encabezadoLayout: {
                //transportista
                nombre: "nombre",
                rfc: "rfc",
                telefono: "telefono",
                metadato: "metadato",
                calle: "calle",
                numero_exterior: "numero_exterior",
                numero_interior: "numero_interior",
                colonia: "colonia",
                codigo_postal: "codigo_postal",
                ciudad: "ciudad",
                municipio: "municipio",
                estado: "estado",
                pais: "pais",
                banco: "banco",
                sucursal: "sucursal",
                cuenta: "cuenta",
                clabe: "clabe",
                swift: "swift",
                aba: "aba",
                banco_interamericano: "banco_interamericano",
                beneficiario: "beneficiario",
                referencia_banco: "referencia_banco",
                //contactos
                aduana_contacto: "aduana_contacto",
                nombre_contacto: "nombre_contacto",
                email_contacto: "email_contacto",
                telefono_contacto: "telefono_contacto",
                movil_contacto: "movil_contacto",
                //domicilios
                aduana_domicilio: "aduana_domicilio",
                calle_domicilio: "calle_domicilio",
                numero_exterior_domicilio: "numero_exterior_domicilio",
                numero_interior_domicilio: "numero_interior_domicilio",
                colonia_domicilio: "colonia_domicilio",
                codigo_postal_domicilio: "codigo_postal_domicilio",
                ciudad_domicilio: "ciudad_domicilio",
                municipio_domicilio: "municipio_domicilio",
                estado_domicilio: "estado_domicilio",
                pais_domicilio: "pais_domicilio",
                notas_domicilio: "notas_domicilio",

            },
            //van vacíos para solo descargar layout con encabezados
            camposLayout: [{
                //transportista
                nombre: "[Nombre del Transportista]",
                rfc: "[RFC del Transportista]",
                telefono: "",
                metadato: "",
                calle: "",
                numero_exterior: "",
                numero_interior: "",
                colonia: "",
                codigo_postal: "",
                ciudad: "Clave de la ciudad",
                municipio: "Clave del municipio",
                estado: "Clave del estado",
                pais: "Clave del país",
                banco: "",
                sucursal: "",
                cuenta: "",
                clabe: "",
                swift: "",
                aba: "",
                banco_interamericano: "",
                beneficiario: "",
                referencia_banco: "Referencia del banco",
                //contactos
                aduana_contacto: "[Clave de Aduana]",
                nombre_contacto: "[Nombre de Contacto]",
                email_contacto: "[Email de Contacto]]",
                telefono_contacto: "[Teléfono del Contacto]]",
                movil_contacto: "[Móvil del Contacto]",
                //domicilios
                aduana_domicilio: "",
                calle_domicilio: "",
                numero_exterior_domicilio: "",
                numero_interior_domicilio: "",
                colonia_domicilio: "",
                codigo_postal_domicilio: "",
                ciudad_domicilio: "Clave de la ciudad",
                municipio_domicilio: "Clave del municipio",
                estado_domicilio: "Clave del estado",
                pais_domicilio: "Clave del país",
                notas_domicilio: "",
            }]
        },
        //DOMICILIOS
        modelDomicilio: {
            id_domicilio_transportista: "",
            transportista: "",
            aduana: "",
            calle: "",
            numero_exterior: "",
            numero_interior: "",
            colonia: "",
            codigo_postal: "",
            ciudad: "",
            municipio: "",
            estado: "",
            pais: "",
            notas: "",
        },
        domicilios: {
            items: [],
        },
        columnsDomicilios: [
            "aduana_nombre",
            "calle",
            "numero_exterior",
            "municipio",
            "estado_nombre",
            "pais_nombre",
            "notas",
            "actions"
        ],
        optionsDomicilios: {
            filterable: [
                "aduana_nombre",
                "calle",
                "numero_exterior",
                "municipio",
                "estado_nombre",
                "pais_nombre",
                "notas",
            ],
            sortable: [
                "aduana_nombre",
                "calle",
                "numero_exterior",
                "municipio",
                "estado_nombre",
                "pais_nombre",
                "notas",
            ],
            headings: {
                aduana_nombre: "Aduana",
                calle: "Calle",
                numero_exterior: "No. Exterior",
                numero_interior: "No. Interior",
                colonia: "Colonia",
                codigo_postal: "CP",
                ciudad: "Ciudad",
                municipio: "Municipio",
                estado_nombre: "Estado",
                pais_nombre: "País",
                notas: "Notas",
                actions: "Operaciones"
            }
        },
        //CONTACTOS
        modelContacto: {
            id_contacto_transportista: '',
            transportista: '',
            aduana: '',
            nombre: '',
            email: '',
            telefono: '',
            movil: '',
        },
        contactos: {
            items: [],
        },
        columnsContactos: [
            "aduana_nombre",
            "nombre",
            "email",
            "telefono",
            "movil",
            "actions"
        ],
        optionsContactos: {
            filterable: [
                "aduana_nombre",
                "nombre",
                "email",
                "telefono",
                "movil",
            ],
            sortable: [
                "aduana_nombre",
                "nombre",
                "email",
                "telefono",
                "movil",
            ],

            headings: {
                aduana: "Aduana",
                nombre: "Nombre Contacto",
                email: "Email",
                telefono: "Telefono",
                movil: "Móvil",
                actions: "Operaciones"
            }
        },
        registro_seleccionado: '',
        registro_seleccionado_metadato: '',
    }),
    computed: {
        datafiltered() {
            if (this.$refs.principalTable != null) {
                return this.$refs.principalTable.allFilteredData;
            } else {
                return this.registros.items;
            }

        },
    },
    methods: {
        nombreAduanaSelect: function (aduana) {
            return aduana.clave + ' - ' + aduana.nombre;
        },
        showDetail: function (row) {
            if (this.registro_seleccionado != row.id_transportista) {
                this.registro_seleccionado = row.id_transportista;
                this.registro_seleccionado_metadato = row.metadato;
                this.cargarDomicilios();
                this.cargarContactos();
                var detallesAbiertos = this.$refs.principalTable.openChildRows;
                for (var k in detallesAbiertos) { //Cerramos detalles abiertos
                    if (detallesAbiertos[k] != row.id_transportista)
                        this.$refs.principalTable.toggleChildRow(detallesAbiertos[k]);
                }
            } else { //Significa que dio clic en '-' solo cerramos el detalle y no hacemos nada
                this.registro_seleccionado = '';
                this.registro_seleccionado_metadato = '';
            }
            this.$refs.principalTable.toggleChildRow(row.id_transportista); //Mostramos detalle seleccionado

        },
        openModal: function (type) {
            if (type === 1) {
                this.limpiarModel();
                this.title = "Nuevo Transportista";
                this.update = false;
            } else {
                this.title = "Actualizar Transportista";
                this.update = true;
            }
            this.modal = true;
        },
        limpiarModel: function () {
            for (var k in this.model) {
                this.model[k] = "";
            }
            this.model.cliente = this.$local_storage.get("id_cliente");
        },

        guardar() {
            const datos = this.model;

            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var metodo = "post";
                var urlCliente = this.URL;
                if (this.update == true) {
                    metodo = "put";
                    urlCliente += this.model.id_transportista + "/";
                }
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });
                        this.cargar();
                        this.$root.$dialogLoader.hide();
                        this.modal = false;
                    })
                    .catch(error => {
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar los datos"
                            //showConfirmButton: false,
                        });
                        console.log(error);
                        this.cargar();
                        this.$root.$dialogLoader.hide();
                        this.modal = false;
                    });
            }
        },

        cargar: function () {
            var datos = {
                cliente: this.$local_storage.get("id_cliente")
            };
            axios
                .post(this.URL + "get_transportistas/", datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.registros.items = res.data;
                        for (var k in this.registros.items) {
                            this.registros.items[k].pais_nombre = this.obtenerPais(this.registros.items[k].pais.id_pais);

                            if (this.registros.items[k].estado != null)
                                this.registros.items[k].estado_nombre = this.obtenerEstado(this.registros.items[k].estado.id_estado);
                        }
                        this.$root.$dialogLoader.hide();
                    }
                })
                .catch(err => {
                   
                    console.log(err);
                    this.$root.$dialogLoader.hide();
                });
        },

        cargarPaises: function () {
            axios
                .get(this.$hostname + "paises/")
                .then(res => {
                    if (typeof res.data !== "undefined") this.paises = res.data;
                    else {
                        this.$swal({
                            type: "warning",
                            title: "Aviso",
                            text: "No se han ingresado datos al catálogo de países",
                            footer: ""
                        });
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el catálogo de países.",
                        footer: ""
                    });
                    console.log(err);
                });
        },

        //Filtramos los estamos
        cargarEstados: function (opcion) {
            if (opcion == 1)
                //1-Limpiar estado seleccionado, 2-No limpiar
                this.model.estado = "";
            if (this.model.pais == null) {
                this.estados = [];
            } else {
                let id_pais = this.model.pais;
                axios
                    .post(this.$hostname + "estados/get_estados_pais/", {
                        pais: id_pais
                    })
                    .then(res => {
                        if (typeof res.data !== "undefined") {
                            this.estados = res.data;
                        } else {
                            this.$swal({
                                type: "warning",
                                title: "Aviso",
                                text: "No se encontraron estados para el país seleccionado",
                                footer: ""
                            });
                        }
                    })
                    .catch(err => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al obtener los estados asociados al país seleccionado.",
                            footer: ""
                        });
                        console.log(err);
                    });
            }
        },

        cargarEstadosTodos: function () {
            axios
                .get(this.$hostname + "estados/")
                .then(res => {
                    if (typeof res.data !== "undefined")
                        this.estados_todos = res.data;
                    else {
                        this.$swal({
                            type: "warning",
                            title: "Aviso",
                            text: "No se han ingresado datos al catálogo de estados",
                            footer: ""
                        });
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el catálogo de estados.",
                        footer: ""
                    });
                    console.log(err);
                });
        },

        cargarAduanas: function () {
            axios
                .get(this.$hostname + "catalogos/aduanas/")
                .then(res => {
                    if (typeof res.data !== "undefined")
                        this.aduanas = res.data;
                    else {
                        this.$swal({
                            type: "warning",
                            title: "Aviso",
                            text: "No se han ingresado datos al catálogo de aduanas",
                            footer: ""
                        });
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el catálogo de aduanas.",
                        footer: ""
                    });
                    console.log(err);
                });
        },

        getRegistro: function (id_registro) {
            axios
                .get(this.URL + id_registro + "/")
                .then(response => {
                    this.model = response.data;
                    this.cargarEstados(2);
                    this.openModal(2); //ACTUALIZAR
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el registro",
                        footer: ""
                    });
                });
        }, //getRegistro

        deleteRegistro: function (id_registro) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value)
                    axios
                    .delete(this.URL + id_registro + "/")
                    .then(response => {
                        this.registro_seleccionado = '';
                        this.registro_seleccionado_metadato = '';
                        this.cargar();
                        this.domicilios.items = [];
                        this.contactos.items = [];
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El registro se eliminó correctamente.",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el registro",
                            footer: ""
                        });
                    });
            });
        }, //delete

        openModalOtro: function (modalTipo, type) {
            if (type === 1)
                this.limpiarModelos();
            if (modalTipo == 'domicilio')
                this.modalDomicilio = true;
            else
                this.modalContacto = true;
        },
        limpiarModelos: function () {
            for (var k in this.modelDomicilio) {
                this.modelDomicilio[k] = "";
            }
            this.modelDomicilio.transportista = this.registro_seleccionado;
            for (var k in this.modelContacto) {
                this.modelContacto[k] = "";
            }
            this.modelContacto.transportista = this.registro_seleccionado;
        },
        cargarEstadosDomicilio: function (opcion) {
            if (opcion == 1)
                //1-Limpiar estado seleccionado, 2-No limpiar
                this.modelDomicilio.estado = "";
            if (this.modelDomicilio.pais == null) {
                this.estados = [];
            } else {
                let id_pais = this.modelDomicilio.pais;
                axios
                    .post(this.$hostname + "estados/get_estados_pais/", {
                        pais: id_pais
                    })
                    .then(res => {
                        if (typeof res.data !== "undefined") {
                            this.estados = res.data;
                        } else {
                            this.$swal({
                                type: "warning",
                                title: "Aviso",
                                text: "No se encontraron estados para el país seleccionado",
                                footer: ""
                            });
                        }
                    })
                    .catch(err => {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al obtener los estados asociados al país seleccionado.",
                            footer: ""
                        });
                        console.log(err);
                    });
            }
        },

        guardarDomicilio: function () {
            const datos = this.modelDomicilio;

            if (!this.$refs.formDomicilio.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var metodo = "post";
                var urlCliente = this.URL + 'domicilios/c/';
                if (this.modelDomicilio.id_domicilio_transportista > 0) {
                    metodo = "put";
                    urlCliente += this.modelDomicilio.id_domicilio_transportista + "/";
                }
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar los datos"
                            //showConfirmButton: false,
                        });
                        console.log(error);
                    }).then(() => {
                        this.cargarDomicilios();
                        this.$root.$dialogLoader.hide();
                        this.modalDomicilio = false;
                    });
            }
        },

        cargarDomicilios: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                transportista: this.registro_seleccionado
            };
            axios
                .post(this.URL + "domicilios/c/list_all/", datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.domicilios.items = res.data;
                        for (var k in this.domicilios.items) {
                            this.domicilios.items[k].pais_nombre = this.obtenerPais(this.domicilios.items[k].pais);
                            this.domicilios.items[k].estado_nombre = this.obtenerEstado(this.domicilios.items[k].estado);
                            this.domicilios.items[k].aduana_nombre = this.obtenerAduana(this.domicilios.items[k].aduana);
                        }
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los domicilios.",
                        footer: ""
                    });
                    console.log(err);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        getRegistroDomicilio: function (id_domicilio) {
            axios
                .get(this.URL + "domicilios/c/" + id_domicilio + "/")
                .then(response => {
                    this.modelDomicilio = response.data;
                    this.cargarEstadosDomicilio(2);
                    this.openModalOtro('domicilio', 2); //ACTUALIZAR
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el registro",
                        footer: ""
                    });
                });
        },

        deleteRegistroDomicilio: function (id_registro) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    axios
                        .delete(this.URL + "domicilios/c/" + id_registro + "/")
                        .then(response => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El registro se eliminó correctamente.",
                                //position: 'bottom-end',
                                //timer: 3000,
                                //showConfirmButton: false,
                                footer: ""
                            });
                        })
                        .catch(error => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el registro",
                                footer: ""
                            });
                        }).then(() => {
                            this.cargarDomicilios();
                            this.$root.$dialogLoader.hide();
                        });
                }

            });
        }, //delete
        obtenerPais(id_pais) {
            let paises = this.paises.filter(function (e) {
                return e.id_pais == id_pais;
            });
            return paises.length > 0 ? paises[0].nombre : "N/A";
        },
        obtenerEstado(id_estado) {
            var estados = [];
            estados = this.estados_todos.filter(function (e) {
                return e.id_estado == id_estado;
            });
            return estados.length > 0 ? estados[0].nombre : "N/A";
        },
        obtenerAduana(id_aduana) {
            let aduanas = this.aduanas.filter(function (e) {
                return e.id_aduana == id_aduana;
            });
            return aduanas.length > 0 ? (aduanas[0].clave + " - " + aduanas[0].nombre) : "N/A";
        },
        verificaAduana: function (aduana, opcion) {
            if (aduana == undefined)
                return false;

            var search = this.aduanas.filter(function (e) {
                return parseInt(e.clave.toString().trim()) == parseInt(aduana.toString().trim());
            });
            if (opcion == 'id')
                return search.length > 0 ? search[0].clave : '';
            else
                return search.length > 0;
        },
        uniqueAduanaDomicilio: function (modelDomicilio) {
            var search = this.domicilios.items.filter(function (e) {
                return e.aduana == modelDomicilio.aduana &&
                    e.id_domicilio_transportista != modelDomicilio.id_domicilio_transportista;
            });
            return search.length > 0 ? 'La aduana ya se registró en otro domicilio.' : true;
        },
        uniqueAduanaContacto: function (modelContacto) {
            var search = this.contactos.items.filter(function (e) {
                return e.aduana == modelContacto.aduana &&
                    e.id_contacto_transportista != modelContacto.id_contacto_transportista;
            });
            return search.length > 0 ? 'La aduana ya se registró en otro contacto.' : true;
        },
        verificaPaisesVacios: function (clave_pais, clave_estado, clave_ciudad, clave_municipio) {
            var erroresText = '';
            if (clave_municipio != undefined && clave_estado == undefined)
                erroresText += "- La clave municipio \"" + clave_municipio + "\" no debe tener el estado vacío.<br>";
            if (clave_ciudad != undefined && clave_estado == undefined)
                erroresText += "- La clave ciudad \"" + clave_ciudad + "\" no debe tener el estado vacío.<br>";
            if (clave_estado != undefined && clave_pais == undefined)
                erroresText += "- La clave estado \"" + clave_estado + "\" no debe tener el país vacío.<br>";
            return erroresText;

        },
        verificaComboPaises: async function (clave_pais, clave_estado, clave_ciudad, clave_municipio) {
            var erroresText = '';
            let verificaP = await this.verificaPais(clave_pais, '');
            if (verificaP == 0) {
                erroresText += "- La clave país \"" + clave_pais + "\" no existe en el sistema.<br>";
            } else {
                let id_pais = await this.verificaPais(clave_pais, 'id');
                if (clave_estado != undefined) {
                    let verificaE = await this.verificaEstado(clave_estado, id_pais, '');
                    if (verificaE == 0) {
                        erroresText += "- La clave estado \"" + clave_estado + "\" no pertenece al país \"" + clave_pais + "\".<br>";
                    } else {
                        let id_estado = await this.verificaEstado(clave_estado, id_pais, 'id');
                        if (clave_ciudad != undefined) {
                            let verificaC = await this.verificaCiudad(clave_ciudad, id_pais, id_estado, '');
                            if (verificaC == 0)
                                erroresText += "- La clave ciudad \"" + clave_ciudad + "\" no pertenece al estado \"" + clave_estado + "\".<br>";
                        }
                        if (clave_municipio != undefined) {
                            let verificaM = await this.verificaMunicipio(clave_municipio, id_pais, id_estado, '');
                            if (verificaM == 0)
                                erroresText += "- La clave municipio \"" + clave_municipio + "\" no pertenece al estado \"" + clave_estado + "\".<br>";
                        }
                    }
                }

            }
            return erroresText;
        },
        verificaPais: function (clave_pais, opcion) {
            var thisObject = this;
            return new Promise(function (resolve, reject) {
                if (clave_pais == undefined)
                    resolve(0);

                var search = thisObject.paises.filter(function (e) {
                    return e.clave_m3.toString().trim().toLowerCase() == clave_pais.toString().trim().toLowerCase();
                });
                if (opcion == 'id')
                    resolve(search.length > 0 ? search[0].id_pais : '');
                else
                    resolve(search.length);
            });

        },
        verificaEstado: function (clave_estado, id_pais, opcion) {
            var thisObject = this;
            return new Promise(function (resolve, reject) {
                if (clave_estado == undefined)
                    resolve(0);

                var search = thisObject.estados_todos.filter(function (e) {
                    return e.clave.toString().trim().toLowerCase() == clave_estado.toString().trim().toLowerCase() &&
                        e.pais == id_pais;
                });
                if (opcion == 'id')
                    resolve(search.length > 0 ? search[0].id_estado : '');
                else
                    resolve(search.length);
            });
        },
        verificaCiudad: function (clave_ciudad, id_pais, id_estado, opcion) {
            var thisObject = this;
            return new Promise(function (resolve, reject) {
                if (clave_ciudad == undefined)
                    resolve(0);
                axios.post(thisObject.$hostname + "catalogos/ciudades/get_ciudades/", {
                        pais: id_pais,
                        estado: id_estado
                    })
                    .then(res => {
                        //console.log(clave_ciudad.toString().trim().trimLeft("0").toLowerCase()); 
                        if (typeof res.data !== "undefined") {
                            thisObject.ciudades = res.data;
                            var search = thisObject.ciudades.filter(function (e) {
                                //console.log("VERIFICA:"+thisObject.removeZerosLeft(e.clave.toString().trim().trimLeft("0").toLowerCase()));
                                return (parseInt(e.clave.toString().trim()) == parseInt(clave_ciudad.toString().trim())) || (e.clave.toString().trim() == clave_ciudad.toString().trim());
                            });
                            if (opcion == 'id')
                                resolve(search.length > 0 ? search[0].descripcion : '');
                            else
                                resolve(search.length);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        resolve(0);
                    });
            });
        },
        verificaMunicipio: function (clave_municipio, id_pais, id_estado, opcion) {
            var thisObject = this;
            return new Promise(function (resolve, reject) {
                if (clave_municipio == undefined)
                    resolve(0);
                axios.post(thisObject.$hostname + "catalogos/municipios/get_municipios/", {
                        pais: id_pais,
                        estado: id_estado
                    })
                    .then(res => {
                        if (typeof res.data !== "undefined") {
                            thisObject.municipios = res.data;
                            var search = thisObject.municipios.filter(function (e) {
                                return (parseInt(e.clave.toString().trim()) == parseInt(clave_municipio.toString().trim())) || (e.clave.toString().trim() == clave_municipio.toString().trim());
                            });
                            if (opcion == 'id')
                                resolve(search.length > 0 ? search[0].descripcion : '');
                            else
                                resolve(search.length);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                        resolve(0);
                    });
            });
        },

        guardarContacto: function () {
            const datos = this.modelContacto;

            if (!this.$refs.formContacto.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                var metodo = "post";
                var urlCliente = this.URL + 'contactos/c/';
                if (this.modelContacto.id_contacto_transportista > 0) {
                    metodo = "put";
                    urlCliente += this.modelContacto.id_contacto_transportista + "/";
                }
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar los datos"
                            //showConfirmButton: false,
                        });
                        console.log(error);
                    }).then(() => {
                        this.cargarContactos();
                        this.$root.$dialogLoader.hide();
                        this.modalContacto = false;
                    });
            }
        },

        cargarContactos: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                transportista: this.registro_seleccionado
            };
            axios
                .post(this.URL + "contactos/c/list_all/", datos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.contactos.items = res.data;
                        for (var k in this.contactos.items) {
                            this.contactos.items[k].aduana_nombre = this.obtenerAduana(this.contactos.items[k].aduana);
                        }
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los contactos.",
                        footer: ""
                    });
                    console.log(err);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        getRegistroContacto: function (id_registro) {
            axios
                .get(this.URL + "contactos/c/" + id_registro + "/")
                .then(response => {
                    this.modelContacto = response.data;
                    this.openModalOtro('contacto', 2); //ACTUALIZAR
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el registro",
                        footer: ""
                    });
                });
        },

        deleteRegistroContacto: function (id_registro) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    axios
                        .delete(this.URL + "contactos/c/" + id_registro + "/")
                        .then(response => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El registro se eliminó correctamente.",
                                //position: 'bottom-end',
                                //timer: 3000,
                                //showConfirmButton: false,
                                footer: ""
                            });
                        })
                        .catch(error => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el registro",
                                footer: ""
                            });
                        }).then(() => {
                            this.cargarContactos();
                            this.$root.$dialogLoader.hide();
                        });
                }

            });
        }, //delete

        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            return false;
        },
        validaCargaLayout: async function (results) {
            var thisObject = this;
            //return new Promise(function(resolve, reject){
            var errores = 0;
            var renglonesLeidos = 0;
            var erroresText = '';
            var aduanasContactoRfc = [];
            var aduanasDomicilioRfc = [];
            try {

                for (var k in results) {
                    renglonesLeidos++;
                    results[k]["user_updated"] = thisObject.$local_storage.get("email");
                    results[k]["cliente"] = thisObject.$local_storage.get("id_cliente");
                    if (results[k]["rfc"] == undefined) {
                        errores++;
                        erroresText += "- En cada renglón se debe especificar el transportista, sin importar que se repita. Para contactos y domicilios no se pueden repetir las aduanas para el mismo transportista.\n";
                    } else {
                        if (aduanasContactoRfc[results[k]["rfc"]] == undefined)
                            aduanasContactoRfc[results[k]["rfc"]] = [];
                        if (aduanasDomicilioRfc[results[k]["rfc"]] == undefined)
                            aduanasDomicilioRfc[results[k]["rfc"]] = [];

                        if (results[k]["aduana_contacto"] != undefined && !thisObject.verificaAduana(results[k]["aduana_contacto"])) {
                            errores++;
                            erroresText += "- La aduana de contacto \"" + results[k]["aduana_contacto"] + "\" no existe en el sistema. Verifique también que la celda sea tipo texto.<br>";
                        } else if (results[k]["aduana_contacto"] != undefined) {
                            // let pos = aduanasContactoRfc[results[k]["rfc"]].indexOf(results[k]["aduana_contacto"]);
                            // if (pos != -1) {
                            //     errores++;
                            //     erroresText+= "- La aduana \""+results[k]["aduana_contacto"]+"\" no debe repetirse para los contactos del transportista \""+results[k]["rfc"]+"\".<br>";
                            // } else {
                            aduanasContactoRfc[results[k]["rfc"]].push(results[k]["aduana_contacto"]);
                            // }
                        }

                        if (results[k]["aduana_domicilio"] != undefined && !thisObject.verificaAduana(results[k]["aduana_domicilio"])) {
                            errores++;
                            erroresText += "- La aduana de domicilio \"" + results[k]["aduana_domicilio"] + "\" no existe en el sistema. Verifique también que la celda sea tipo texto.<br>";
                        } else if (results[k]["aduana_domicilio"] != undefined) {
                            let pos = aduanasDomicilioRfc[results[k]["rfc"]].indexOf(results[k]["aduana_domicilio"]);
                            if (pos != -1) {
                                errores++;
                                erroresText += "- La aduana \"" + results[k]["aduana_domicilio"] + "\" no debe repetirse para los domicilios del transportista \"" + results[k]["rfc"] + "\".<br>";
                            } else {
                                aduanasDomicilioRfc[results[k]["rfc"]].push(results[k]["aduana_domicilio"]);
                            }
                        }

                        let clavesVacias = thisObject.verificaPaisesVacios(results[k]["pais"], results[k]["estado"], results[k]["ciudad"], results[k]["municipio"]);
                        if (clavesVacias.toString().trim().length > 0) {
                            errores++;
                            if (erroresText.indexOf(clavesVacias) == -1)
                                erroresText += clavesVacias;
                        } else {
                            if (results[k]["pais"] != undefined) {
                                let verificaPaises = await thisObject.verificaComboPaises(results[k]["pais"], results[k]["estado"], results[k]["ciudad"], results[k]["municipio"]);
                                if (verificaPaises.toString().trim().length > 0) {
                                    errores++;
                                    if (erroresText.indexOf(verificaPaises) == -1)
                                        erroresText += verificaPaises;
                                }
                            }
                        }

                        let clavesVaciasDomicilio = thisObject.verificaPaisesVacios(results[k]["pais_domicilio"], results[k]["estado_domicilio"], results[k]["ciudad_domicilio"], results[k]["municipio_domicilio"]);
                        if (clavesVaciasDomicilio.toString().trim().length > 0) {
                            errores++;
                            if (erroresText.indexOf(clavesVaciasDomicilio) == -1)
                                erroresText += clavesVaciasDomicilio;
                        } else {
                            if (results[k]["pais_domicilio"] != undefined) {
                                let verificaDomicilioPaises = await thisObject.verificaComboPaises(results[k]["pais_domicilio"], results[k]["estado_domicilio"], results[k]["ciudad_domicilio"], results[k]["municipio_domicilio"]);
                                if (verificaDomicilioPaises.toString().trim().length > 0) {
                                    errores++;
                                    if (erroresText.indexOf(verificaDomicilioPaises) == -1)
                                        erroresText += verificaDomicilioPaises;
                                }
                            }
                        }

                    }
                    //console.log("Key is " + k + ", value is" + results[k]);
                }

                if (renglonesLeidos == 0) {
                    errores++;
                    erroresText += "- No hay datos en el layout. Verifique que exista información a partir del 3er renglón.\n";
                }

                return ({
                    "errores": errores,
                    "erroresText": erroresText
                });

            } catch (error) {
                console.log(error);
                thisObject.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
            }
            //}); //promise

        },
        handleSuccess: async function ({
            results,
            header
        }) {
            var errores = 0;
            var erroresText = '';
            var aduanasContactoRfc = [];
            var aduanasDomicilioRfc = [];
            this.importData = [];
            try {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let validaciones = await this.validaCargaLayout(results);
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText,
                    });
                    this.$root.$dialogLoader.hide();
                } else {
                    for (var k in results) {
                        if (this.importData[results[k]["rfc"]] == undefined)
                            this.importData[results[k]["rfc"]] = {};
                        if (this.importData[results[k]["rfc"]]['contactos'] == undefined)
                            this.importData[results[k]["rfc"]]['contactos'] = [];
                        if (this.importData[results[k]["rfc"]]['domicilios'] == undefined)
                            this.importData[results[k]["rfc"]]['domicilios'] = [];

                        var id_pais = results[k]["pais"] != undefined ? await this.verificaPais(results[k]["pais"], 'id') : '';
                        if (id_pais != '')
                            var id_estado = results[k]["estado"] != undefined ? await this.verificaEstado(results[k]["estado"], id_pais, 'id') : '';
                        else
                            var id_estado = '';

                        this.importData[results[k]["rfc"]]['transportista'] = {
                            nombre: results[k]["nombre"],
                            rfc: results[k]["rfc"],
                            telefono: results[k]["telefono"],
                            metadato: results[k]["metadato"],
                            calle: results[k]["calle"],
                            numero_exterior: results[k]["numero_exterior"],
                            numero_interior: results[k]["numero_interior"],
                            colonia: results[k]["colonia"],
                            codigo_postal: results[k]["codigo_postal"],
                            ciudad: results[k]["ciudad"] != undefined ? await this.verificaCiudad(results[k]["ciudad"], id_pais, id_estado, 'id') : '',
                            municipio: results[k]["municipio"] != undefined ? await this.verificaMunicipio(results[k]["municipio"], id_pais, id_estado, 'id') : '',
                            estado: id_estado,
                            pais: id_pais,
                            banco: results[k]["banco"],
                            sucursal: results[k]["sucursal"],
                            cuenta: results[k]["cuenta"],
                            clabe: results[k]["clabe"],
                            swift: results[k]["swift"],
                            aba: results[k]["aba"],
                            banco_interamericano: results[k]["banco_interamericano"],
                            beneficiario: results[k]["beneficiario"],
                            referencia_banco: results[k]["referencia_banco"],
                            cliente: results[k]["cliente"],
                            user_updated: results[k]["user_updated"],
                        }

                        results[k]["aduana_contacto"] = this.verificaAduana(results[k]["aduana_contacto"], "id");
                        if (results[k]["aduana_contacto"] != undefined && results[k]["aduana_contacto"] != false)
                            this.importData[results[k]["rfc"]]['contactos'].push({
                                aduana: results[k]["aduana_contacto"],
                                nombre: results[k]["nombre_contacto"],
                                email: results[k]["email_contacto"],
                                telefono: results[k]["telefono_contacto"],
                                movil: results[k]["movil_contacto"],
                            });

                        var id_pais_domicilio = results[k]["pais_domicilio"] != undefined ? await this.verificaPais(results[k]["pais_domicilio"], 'id') : '';
                        if (id_pais_domicilio != '')
                            var id_estado_domicilio = results[k]["estado_domicilio"] != undefined ? await this.verificaEstado(results[k]["estado_domicilio"], id_pais_domicilio, 'id') : '';
                        else
                            var id_estado_domicilio = '';

                        results[k]["aduana_domicilio"] = this.verificaAduana(results[k]["aduana_domicilio"], "id");
                        if (results[k]["aduana_domicilio"] != undefined && results[k]["aduana_domicilio"] != false)
                            this.importData[results[k]["rfc"]]['domicilios'].push({
                                aduana: results[k]["aduana_domicilio"],
                                calle: results[k]["calle_domicilio"],
                                numero_exterior: results[k]["numero_exterior_domicilio"],
                                numero_interior: results[k]["numero_interior_domicilio"],
                                colonia: results[k]["colonia_domicilio"],
                                codigo_postal: results[k]["codigo_postal_domicilio"],
                                ciudad: results[k]["ciudad_domicilio"] != undefined ? await this.verificaCiudad(results[k]["ciudad_domicilio"], id_pais_domicilio, id_estado_domicilio, 'id') : '',
                                municipio: results[k]["municipio_domicilio"] != undefined ? await this.verificaMunicipio(results[k]["municipio_domicilio"], id_pais_domicilio, id_estado_domicilio, 'id') : '',
                                estado: id_estado_domicilio,
                                pais: id_pais_domicilio,
                                notas: results[k]["notas_domicilio"],
                            });
                    }

                    var resultadoFinal = [];
                    for (var k in this.importData) {
                        resultadoFinal.push(this.importData[k]);
                    }

                    axios
                        .post(this.URL + "importar_transportistas/", resultadoFinal)
                        .then(() => {
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "Los datos se guardaron correctamente",
                                footer: ""
                            });
                        })
                        .catch(err => {
                            var errores = "";
                            if (typeof err.response.data != "undefined") {
                                if (typeof err.response.data == "string") {
                                    let pos = errores.indexOf(err.response.data);
                                    if (pos < 0) {
                                        errores += err.response.data;
                                        errores += "<br>";
                                    }
                                } else
                                    for (var i = 0; i < err.response.data.length; i++) {
                                        Object.keys(err.response.data[i]).forEach(function (key) {
                                            var errors = err.response.data[i][key];
                                            if (key != 'contactos' && key != 'domicilios') { //Este trae 2 niveles, por eso el campo queda en la key2
                                                Object.keys(errors).forEach(function (key2) {
                                                    let pos = errores.indexOf(key + ": " + errors[key2]);
                                                    if (pos < 0) {
                                                        errores += key + ": " + errors[key2];
                                                        errores += "<br>";
                                                    }
                                                });
                                            } else { //contactos y domicilios, traen 3 niveles, por eso el campo queda en la key3
                                                Object.keys(errors).forEach(function (key2) {
                                                    Object.keys(errors[key2]).forEach(function (key3) {
                                                        let pos = errores.indexOf(key3 + ": " + errors[key2][key3]);
                                                        if (pos < 0) {
                                                            errores += key3 + ": " + errors[key2][key3];
                                                            errores += "<br>";
                                                        }

                                                    });
                                                });
                                            }

                                        });
                                    }
                            }
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo. \nVerifique que los encabezados correspondan con el layout.",
                                footer: errores
                            });
                        })
                        .then(() => {
                            this.cargar();
                            this.$root.$dialogLoader.hide();
                        });
                }

            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message,
                });
                this.$root.$dialogLoader.hide();
            }
        },
        selectComboPais(id) {
            this.model.pais = id;
        },
        selectComboEstado(id) {
            this.model.estado = id;
        },
        selectComboCiudad(id) {
            this.model.ciudad = id;
        },
        selectComboMunicipio(id) {
            this.model.municipio = id;
        },
        selectComboPaisDomicilio(id) {
            this.modelDomicilio.pais = id;
        },
        selectComboEstadoDomicilio(id) {
            this.modelDomicilio.estado = id;
        },
        selectComboCiudadDomicilio(id) {
            this.modelDomicilio.ciudad = id;
        },
        selectComboMunicipioDomicilio(id) {
            this.modelDomicilio.municipio = id;
        },
    }, //methods
    created: function () {
        this.URL = this.$hostname + "catalogos/transportistas/";
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        this.cargarPaises();
        this.cargarEstadosTodos();
        this.cargarAduanas();
        this.cargar();
    }
};
</script>

<style scoped>
#transportistas>>>.VueTables__child-row-toggler {
    display: none;
}
</style>
